import { useLayoutEffect, useRef, useState } from "react";

/**
 * True for a moment after a row becomes done, to play its tick-off animation
 * (`appointment-overlay__task--just-completed`). Rows that were already done
 * when they appeared don't animate.
 *
 * A layout effect, so the animation class is on before the browser paints:
 * with a plain effect the row showed as done for one frame first, then
 * snapped back to animate ("Completed" jerked, then faded).
 */
export const useJustCompleted = (isCompleted: boolean): boolean => {
  const wasCompleted = useRef(isCompleted);
  const [justCompleted, setJustCompleted] = useState(false);

  useLayoutEffect(() => {
    const changedToDone = isCompleted && !wasCompleted.current;
    wasCompleted.current = isCompleted;
    if (!changedToDone) {
      if (!isCompleted) setJustCompleted(false);
      return;
    }
    setJustCompleted(true);
    const timer = window.setTimeout(() => setJustCompleted(false), 700);
    return () => window.clearTimeout(timer);
  }, [isCompleted]);

  return justCompleted;
};
